import geography from "../philippine_provinces_cities_municipalities_and_barangays_2019v2.json";
const state = {
    regions: [],
    provinces: [],
    cities: [],
    barangays: [],
};
const mutations = {
    SET_REGIONS(state, regions) {
        state.regions = regions;
    },
    SET_PROVINCES(state, provinces) {
        state.provinces = provinces;
    },
    SET_CITIES(state, cities) {
        state.cities = cities;
    },
    SET_BARANGAYS(state, barangays) {
        state.barangays = barangays;
    },
};
const actions = {
    async getRegions({ commit }) {
        let list = [];
        let regions = Object.keys(geography);
        regions.forEach((region) => {
            list.push(region);
        });
        list.sort((a, b) => parseFloat(a) - parseFloat(b));
        console.log(regions)
        commit("SET_REGIONS", list);
    },
    async getProvinces({ commit }, payload) {
        commit("SET_PROVINCES", Object.keys(geography[payload.region].province_list));
    },
    async getCities({ commit }, payload) {
        commit(
            "SET_CITIES",
            Object.keys(geography[payload.region].province_list[payload.province].municipality_list)
        );
    },
    async getBarangays({ commit }, payload) {
        let list = [];
        let barangays =
            geography[payload.region].province_list[payload.province].municipality_list[payload.city].barangay_list;
        barangays.forEach((barangay) => {
            list.push(barangay);
        });

        commit("SET_BARANGAYS", list);
    },
};
const getters = {
    regions: (state) => state.regions,
    provinces: (state) => state.provinces,
    cities: (state) => state.cities,
    barangays: (state) => state.barangays,
};

export default {
	state,
	mutations,
	actions,
	getters
};
